import type { SimpleMarketplaceResponse } from '@yoop/data-access-model';
import isNil from 'ramda/src/isNil';

/**
 * Predicate for orphan marketplaces, that is without a parentMarketplaceId
 * @param marketplace
 */
export const orphan = (marketplace: SimpleMarketplaceResponse): boolean =>
  isNil(marketplace.parentMarketplaceId);
